export const APPLICATION_FORM_EVENT = 'mosprom:open-application-form';

export type ApplicationFormSource = {
  type?: 'event' | 'resolution' | 'service' | 'header' | 'footer' | 'media' | 'page';
  id?: number | string;
  title?: string;
  path?: string;
};

const TYPE_LABELS: Record<NonNullable<ApplicationFormSource['type']>, string> = {
  event: 'мероприятие',
  resolution: 'мера поддержки',
  service: 'услуга',
  header: 'шапка сайта',
  footer: 'футер',
  media: 'медиа / СМИ',
  page: 'страница',
};

const isApplicationFormSource = (value: unknown): value is ApplicationFormSource => {
  if (value === null || value === undefined || typeof value !== 'object') {
    return false;
  }
  const record = value as Record<string, unknown>;
  if (record.nativeEvent != null || typeof record.preventDefault === 'function') {
    return false;
  }
  return true;
};

export const formatApplicationSourceLine = (
  source?: ApplicationFormSource | null,
): string => {
  const path = source?.path ||
    (typeof window !== 'undefined' ? window.location.pathname : '');

  if (!source) {
    return path ? `Источник: ${path}` : '';
  }

  const typeLabel = source.type ? (TYPE_LABELS[source.type] || '') : '';
  const title = source.title ? source.title.replace(/\s+/g, ' ').trim() : '';
  const titlePart = title ? `"${title}"` : '';
  const idPart = source.id != null && `${source.id}` !== ''
    ? `(id ${source.id})`
    : '';
  const main = [typeLabel, titlePart, idPart].filter(Boolean).join(' ').trim();

  if (main && path) {
    return `Источник: ${main}, ${path}`;
  }
  if (main) {
    return `Источник: ${main}`;
  }
  if (path) {
    return `Источник: ${path}`;
  }
  return '';
};

export const openApplicationForm = (source?: ApplicationFormSource): void => {
  window.dispatchEvent(new CustomEvent(APPLICATION_FORM_EVENT, {
    detail: isApplicationFormSource(source) ? source : null,
  }));
};
